import React from "react";
import PropTypes from "prop-types";
import {useName, Collection} from "@morningtrain/react-resources";
import Select from '../simpletons/Select';

function ResourceSelector(props) {

    const name = useName(props.name);
    const {namespace, resourceName, operationName} = props;

    const selectProps = {...props};

    delete selectProps.namespace;
    delete selectProps.resourceName;
    delete selectProps.operationName;

    const SelectComponent = props.selectComponent;

    return (
        <Collection namespace={namespace}
                    resourceName={resourceName}
                    operationName={operationName}
                    group={'resource_selector_' + name}
                    autoFetch={true}
                    provideErrors={false}>
            {props.children}
            <SelectComponent {...selectProps} />
        </Collection>
    );
}

ResourceSelector.defaultProps = {
    ...Select.defaultProps,
    namespace: 'api',
    operationName: 'index',
    selectComponent: Select,
};

ResourceSelector.propTypes = {
    ...Select.propTypes,
    namespace: PropTypes.string,
    resourceName: PropTypes.string.isRequired,
    operationName: PropTypes.string,
    selectComponent: PropTypes.any,
};

export default ResourceSelector;
